import { render, staticRenderFns } from "./ticket-cost-infos.vue?vue&type=template&id=151bfd8c&scoped=true"
import script from "./ticket-cost-infos.vue?vue&type=script&lang=js"
export * from "./ticket-cost-infos.vue?vue&type=script&lang=js"
import style0 from "./ticket-cost-infos.vue?vue&type=style&index=0&id=151bfd8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151bfd8c",
  null
  
)

export default component.exports